/**
 * The heading every page gets.
 *
 * Before this, only the project page rendered a title — so `/deployments`,
 * `/processes` and `/audit` were untitled screens that relied entirely on the nav
 * highlight, which on a phone was an unlabelled icon.
 *
 * `meta` is for the one number that describes the page's contents; `actions` is
 * for what you came here to do.
 */
export function PageHeader({ title, meta, actions, children }) {
    return (
        <div className="mb-5">
            <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-2">
                <div className="flex min-w-0 items-baseline gap-3">
                    <h1 className="page-title truncate">{title}</h1>
                    {meta ? <p className="muted shrink-0 text-xs tabular-nums">{meta}</p> : null}
                </div>
                {/* Wraps on its own: three actions and a long title do not share 375px. */}
                {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
            </div>
            {children}
        </div>
    );
}
